import React, { useState } from "react";
import classnames from "classnames";
import { DraggablePanel } from "./draggable-panel";

export const DraggablePanelButton = ({ children, ...props }) => {
    const [showPanel, setShowPanel] = useState(false);
    const togglePanel = (bool) => {
        const useBool = bool ? bool : !showPanel;
        setShowPanel(useBool);
    };

    return (
        <div>
            <button
                aria-label={props.name || "draggable"}
                className={classnames("button", { "-pressed": showPanel })}
                title="Panel"
                disabled={props.disabled}
                onClick={() => togglePanel(!showPanel)}
            >
                {props.text}
            </button>
            {showPanel && (
                <DraggablePanel
                    togglePanel={togglePanel}
                    roleType={props.roleType}
                    roleLabel={props.roleLabel}
                >
                    {children}
                </DraggablePanel>
            )}
        </div>
    );
};
